export const deMultispace = str => str.replace(/[\s\uFEFF\xA0]{2,}/g, ' ');
